import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import qs from 'qs';
import Slider from 'react-slick';
import { Link } from 'react-router-dom';
import merge from 'lodash/merge';
import queryUtil from '../../modules/ajio-util/query';
// import TopDescription from "./TopDescription";
import { getDecodedString } from '../../modules/ajio-util/stringDecoder';
import properties from '../../modules/ajio-util/properties';

import { getLuxeFlags } from '../../Flags/selectors';
import { getCurrentStore } from '../../refresh/selectors/metaData';
import { gtmEventPush } from '../../modules/ga/GTMdatalayer';
import luxeScreens from '../../refresh/constants/luxeScreenType';

const imageBaseUrl = properties.getProperty('imageBaseUrl');

class NoResultPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      itemInGenderSlick: 1,
      itemScaled: false,
      itemsInFacetSlick: 1
    };
  }

  getLinkURL(query) {
    const { location = {} } = this.props;

    let { query: innerQueryObj = {} } = query;
    let { value = '' } = innerQueryObj;

    return `${location.pathname}?${qs.stringify({
      ...queryUtil.parseSearch(location.search),
      query: value
    })}`;
  }

  componentDidMount() {
    let infoWrapper = this.refs['info-section'];
    let facetSlickItem = this.refs['facet-slick-item'];
    let genderSlickItem = this.refs['gender-slick-item'];
    let gullyWidth = 25;

    if (!this.state.itemScaled && infoWrapper && (facetSlickItem || genderSlickItem)) {
      if (genderSlickItem) {
        this.state.itemInGenderSlick = Math.floor(
          infoWrapper.offsetWidth / (genderSlickItem.offsetWidth + gullyWidth * 2)
        );
      }
      if (facetSlickItem) {
        this.state.itemsInFacetSlick = Math.floor(
          infoWrapper.offsetWidth / (facetSlickItem.offsetWidth + gullyWidth * 2)
        );
      }
      this.setState({
        itemsInFacetSlick: this.state.itemsInFacetSlick,
        itemScaled: true,
        itemInGenderSlick: this.state.itemInGenderSlick
      });
    }
  }

  slickItem(className = 'slick', items = 5, facetNodes = []) {
    let slickSettings = {
      dots: false,
      infinite: false,
      slidesToShow: items,
      slidesToScroll: 1,
      arrows: true,
      autoplay: false,
      className
    };

    let returnItem = facetNodes;
    if (facetNodes.length > items) {
      returnItem = (
        <Slider {...slickSettings} ref={className}>
          {facetNodes}
        </Slider>
      );
    }
    return returnItem;
  }

  getFacetsQuery() {
    const { facetsQuery } = this.props;
    if (Object.keys(facetsQuery).length) {
      return merge({}, facetsQuery);
    } else {
      return null;
    }
  }

  fetchData({ query: { value = '' } }, { code = '', type = '' }) {
    let facetsData = '';
    const facetsQuery = this.getFacetsQuery() || {};

    if (facetsQuery[type] && facetsQuery[type].length && facetsQuery[type].includes(code)) {
      let index = facetsQuery[type].indexOf(code);
      facetsQuery[type].splice(index, 1);
      facetsQuery[type].length == 0 ? delete facetsQuery[type] : null;
    } else if (code && type) {
      facetsData = `${type}:${code}`;
    }

    for (let key in facetsQuery) {
      if (Array.isArray(facetsQuery[key])) {
        facetsQuery[key].reduce((accumulator, currentValue) => {
          facetsData = facetsData
            ? `${facetsData}:${key}:${currentValue}`
            : `${key}:${currentValue}`;
        }, facetsData);
      }
    }
    this.props.pushToHistory({ query: value, facets: facetsData });
  }

  render() {
    const {
      luxeStore,
      search: { screenName = '', screenType = '' }
    } = luxeScreens;
    let {
      newDesignLuxe,
      freeTextSearch = '',
      categoryforheader = '',
      facets = [],
      categoryCode,
      imageStyleType,
      topdescription = '',
      entities = {},
      autoCorrect = false,
      request = {}
    } = this.props;
    const { location = {} } = this.props;
    let originalSearchTerm;
    if (autoCorrect) {
      const { query = {} } = request;
      originalSearchTerm = query.text || '';
    }

    var linkURL = {};
    var listItems = [];
    var facetItems = {};
    var url = '';
    var code = '';
    var name = '';
    var genderFacets = false;

    let sortedBrickItem = [];
    let sortedListItem = [];
    let flagCarousel = true;
    let isBrickFacet = false;
    let isGenderFacets = false;
    // let facetItems = [];
    let brickFacetNode = null;
    let genderFacetNode = null;
    let brickItemsList = null;
    let brickItems = null;

    let isSearchPage = false;

    if (entities.brickstyletype) {
      let facetItems = entities.brickstyletype.childrens;

      if (imageStyleType) {
        const genderFacets = false;
        brickItems = facetItems.map((entityId, i) => {
          const entity = entities[entityId] || {};
          const { selected = false, code, query = {} } = entity;
          let linkURL = this.getLinkURL(query);
          return (
            <div className="facet-inline" key={`facet-cat-${i}`} ref="facet-slick-item">
              <div
                onClick={() => {
                  this.fetchData(query, { code, type: 'brickstyletype' });
                }}
              >
                <div className="fnl-checkbox">
                  <input type="checkbox" className="facetChkBox" value="" checked={selected} />
                  <label className="facetgenderLabel" />
                  <div className="chkBoxTxt styleTypeFacetText">
                    <img
                      alt="slider1"
                      className="fnl-plp-slick fnl-plp-slickhoimg"
                      src={`${imageBaseUrl}/static/img/categorycodes/${categoryCode}/${code}.png`}
                    />
                    <div className="">{code}</div>
                  </div>
                </div>
              </div>
            </div>
          );
        });
        brickItems = this.slickItem('facet-slick', this.state.itemsInFacetSlick, brickItems);
      } else {
        flagCarousel = false;
        brickItemsList = facetItems.map((entityId, key) => {
          const entity = entities[entityId] || {};
          const { name, selected = false, query = {}, code = '' } = entity;
          let linkURL = this.getLinkURL(query);
          return (
            <li key={`facet-items-${key}`} ref="facet-slick-item">
              <div className="facet-inline">
                <div
                  onClick={() => {
                    this.fetchData(query, { code, type: 'brickstyletype' });
                  }}
                >
                  <div className="fnl-checkbox">
                    <input
                      type="checkbox"
                      name={name}
                      id={name}
                      className="facetChkBox"
                      value={name}
                      checked={selected}
                    />
                    <label className="facetgenderLabel" />
                    <span>{name} </span>
                  </div>
                </div>
              </div>
            </li>
          );
        });
      }
    }

    if (entities.genderfilter) {
      let facetItems = entities.genderfilter.childrens;
      let genderFacetsNode;

      /**
       * Gender facets should not be visible for category pages contains url ("/c/")
       */
      if (isSearchPage) {
        genderFacetsNode = facetItems.map((entityId, i) => {
          const entity = entities[entityId] || {};
          const { name, selected = false, code, query = {} } = entity;
          let linkURL = this.getLinkURL(query);
          return (
            <div className="facet-inline" key={`facet-brick-${i}`} ref="gender-slick-item">
              <div
                onClick={() => {
                  this.fetchData(query, { code, type: 'genderfilter' });
                }}
              >
                <div className="fnl-checkbox">
                  <input type="checkbox" className="facetChkBox" value="" checked={selected} />
                  <label className="facetgenderLabel" />
                  <div className="chkBoxTxt styleTypeFacetText">
                    <img
                      alt="slider1"
                      className="fnl-plp-slick fnl-plp-slickhoimg"
                      src={`${imageBaseUrl}/static/img/genderFacetsSLP/${code}.png`}
                    />
                    <div className="">{code}</div>
                  </div>
                </div>
              </div>
            </div>
          );
        });
        genderFacetNode = this.slickItem(
          'gender-slick',
          this.state.itemInGenderSlick,
          genderFacetsNode
        );
      }
    }
    freeTextSearch = getDecodedString(freeTextSearch) || '';

    return (
      <div className={`${newDesignLuxe ? 'luxe-newdesign' : ''} no-result-info`} ref="info-section">
        {autoCorrect && originalSearchTerm ? (
          <div className="fnl-slpsearch-firstLine-no-result">
            Sorry !! No Results found for <span>"{originalSearchTerm}"</span> . Showing results for{' '}
            <span>"{freeTextSearch}".</span>
          </div>
        ) : (
          ''
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { products = {}, facets = {}, productsAdditionalInfo = {}, request = {}, flags } = state;
  const { currentFacets = {} } = facets;
  const { results = [], entities = {} } = currentFacets;
  const { currentFacets: { query: facetsQuery = {} } = {} } = facets;
  const {
    categoryDescription,
    freeTextSearch,
    categoryforheader,
    categoryCode,
    imageStyleType,
    topdescription,
    autoCorrect
  } = productsAdditionalInfo;

  const { isDesktopThemeEnable } = getLuxeFlags(flags);
  const storeName = getCurrentStore(state);

  const newDesignLuxe = isDesktopThemeEnable === 'ON' && storeName === 'luxe';

  return {
    newDesignLuxe,
    categoryDescription,
    freeTextSearch,
    categoryforheader,
    facets,
    categoryCode,
    imageStyleType,
    topdescription,
    entities,
    autoCorrect,
    request,
    facetsQuery
  };
};

export default withRouter(connect(mapStateToProps)(NoResultPage));
